import { createContext, Dispatch, useContext, useReducer } from "react";
import React from "react";
const FormContext = createContext<{ state: any; dispatch: Dispatch<any> }>({
  state: { files: {} },
  dispatch: () => {},
});

const reducer = function (state: any, action: any): any {
  switch (action.type) {
    case "updateFiles":
      return {
        ...state,
        files: { ...state.files, [action.value.fieldName]: action.value.fileData },
      };
    case "removeFiles":
      const getFiles = { ...state.files };
      delete getFiles[action.value.fieldName];
      return { ...state, files: { ...getFiles } };
    default:
      throw new Error(`Unhandled action type: ${action.type}`);
  }
};

export const FileUploadContext: React.FunctionComponent<any> = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, {
    files: {},
  });
  const value = { state, dispatch };
  return <FormContext.Provider value={value}>{children}</FormContext.Provider>;
};

export const useAppFormContext = (): {
  state: any;
  dispatch: Dispatch<any>;
} => {
  const context = useContext(FormContext);
  if (!context) {
    throw new Error("useAppFormContext within provider");
  }
  return context;
};
